import { LegalParameterService } from '@/core/services'

// Mixin compartido para el label dinámico de asignación familiar ("10% RMV = S/ 123.00").
// Lee la RMV y la tasa VIGENTES HOY (DEF-01: consulta por fecha, ya no "el último año registrado") y expone
// el computed familyAllowanceLabel. Reutilizado por el editor de contrato (ConditionsTab) y el detalle
// (ContractDetail) para evitar duplicar la lógica.
const todayIso = () => {
  const d = new Date()
  const pad = n => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
}

export default {
  data() {
    return { legalParam: null }
  },
  created() {
    LegalParameterService.valuesAt(todayIso())
      .then(r => { this.legalParam = r.payload || null })
      .catch(() => { this.legalParam = null })
  },
  computed: {
    // "{tasa*100}% RMV = S/ {rmv*tasa}"; '' si no hay parámetro vigente hoy.
    familyAllowanceLabel() {
      const lp = this.legalParam
      if (!lp || lp.RMV == null || lp.FAMILY_ALLOWANCE_RATE == null) return ''
      const pct = parseFloat((Number(lp.FAMILY_ALLOWANCE_RATE) * 100).toFixed(4))
      const amount = (Number(lp.RMV) * Number(lp.FAMILY_ALLOWANCE_RATE)).toFixed(2)
      return `${pct}% RMV = S/ ${amount}`
    },
  },
}
